import { createTheme, densities, getTheme, themes } from '@weave-mui/styles';
export async function loadAppTheme() {
    const muiBase = createTheme();
    const weaveTheme = await getTheme(themes.LIGHT_GRAY, densities.MEDIUM);
    return createTheme(muiBase, weaveTheme, {
        palette: {
            mode: 'light',
            primary: { main: '#0696D7' },
            secondary: { main: '#FF6B35' },
            error: { main: '#E53935' },
            warning: { main: '#F57C00' },
            success: { main: '#43A047' },
            info: { main: '#0288D1' },
            background: { default: '#f0f2f5', paper: '#ffffff' },
            divider: 'rgba(0,0,0,0.09)'
        },
        typography: {
            fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
            h4: { fontWeight: 600 },
            h6: { fontWeight: 600 }
        },
        shape: { borderRadius: 8 },
        components: {
            MuiAppBar: {
                defaultProps: { color: 'transparent', elevation: 0 },
                styleOverrides: {
                    root: {
                        backgroundColor: '#ffffff',
                        color: '#1a1a2e',
                        borderBottom: '1px solid rgba(0,0,0,0.09)',
                        backgroundImage: 'none'
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: { textTransform: 'none', fontWeight: 500 }
                }
            },
            MuiPaper: {
                styleOverrides: { root: { backgroundImage: 'none' } }
            }
        }
    });
}
